import { Github, Mail, Linkedin, Sparkles, Zap, Bot, BookOpen } from 'lucide-react';
import TelegramIcon from '../components/icons/TelegramIcon';

export const socialLinks = [
  {
    id: 'github',
    icon: Github,
    label: 'GitHub',
    url: 'https://github.com/Vikquick',
    gradientClass: 'from-purple-500 to-purple-700',
  },
  {
    id: 'telegram',
    icon: TelegramIcon,
    label: 'Telegram',
    url: 'https://t.me/vikquick24',
    gradientClass: 'from-blue-500 to-cyan-500',
  },
  {
    id: 'email',
    icon: Mail,
    label: 'Email',
    url: 'mailto:mail_me@vikquick.ru',
    gradientClass: 'from-cyan-500 to-teal-500',
  },
  {
    id: 'linkedin',
    icon: Linkedin,
    label: 'LinkedIn',
    url: 'https://linkedin.com/in/vikquick21',
    gradientClass: 'from-sky-500 to-blue-600',
  },
];

export const projects = [
  {
    id: 'moonshine-calculator',
    name: 'Калькулятор Самогонщика',
    description:
      'Telegram Mini App для расчётов самогоноварения. Калькуляторы разбавления, голов/хвостов, сахара и многое другое.',
    tech: ['Telegram Bot API', 'JS', 'Python'],
    icon: Bot,
    color: 'from-amber-500 to-orange-600',
    url: 'https://t.me/moonshine_calc_bot',
  },
  {
    id: 'cosmic-quiz',
    name: 'Космический Квиз',
    description:
      'Telegram Mini App — тест из 17 вопросов, чтобы узнать, к какому легиону Адептус Астартес принадлежит твоя душа!',
    tech: ['Telegram Bot API', 'JS', 'Python'],
    icon: Zap,
    color: 'from-yellow-500 to-red-600',
    url: 'https://t.me/cosmic_quiz_bot',
  },
  {
    id: 'expense-calculator',
    name: 'Калькулятор Расходов',
    description:
      'Дели расходы с друзьями просто! Создавай цели вместе, записывай траты, и бот рассчитает, кто кому должен. Всё честно и быстро!',
    tech: ['Telegram Bot API', 'JS', 'Python'],
    icon: Sparkles,
    color: 'from-cyan-400 to-pink-500',
    url: 'https://t.me/best_friends_calc_bot',
  },
  {
    id: 'liber-imperium',
    name: 'Liber Imperium',
    description:
      'Liber Imperium — справочник по вселенной Warhammer на Elixir. Лор, фракции, мониторинг и собственный S3-сторадж.',
    tech: ['Elixir', 'Phoenix', 'PostgreSQL'],
    icon: BookOpen,
    color: 'from-rose-700 to-amber-600',
    url: 'https://warhammer.vikquick.ru',
  },
];

export const skills = [
  { id: 'python', name: 'Python', category: 'core' },
  { id: 'jsts', name: 'JS/TS', category: 'core' },
  { id: 'selenium', name: 'Selenium', category: 'testing' },
  { id: 'playwright', name: 'Playwright', category: 'testing' },
  { id: 'pytest', name: 'Pytest', category: 'testing' },
  { id: 'storybook', name: 'Storybook', category: 'testing' },
  { id: 'aws', name: 'AWS', category: 'cloud' },
  { id: 'lambda', name: 'Lambda', category: 'cloud' },
  { id: 'boto3', name: 'boto3', category: 'cloud' },
  { id: 'docker', name: 'Docker', category: 'devops' },
  { id: 'jenkins', name: 'Jenkins', category: 'devops' },
  { id: 'bamboo', name: 'Bamboo', category: 'devops' },
  { id: 'git', name: 'Git', category: 'tools' },
  { id: 'rest-api', name: 'REST API', category: 'tools' },
  { id: 'websocket', name: 'WebSocket', category: 'tools' },
  { id: 'soap', name: 'SOAP', category: 'tools' },
  { id: 'opencv', name: 'OpenCV', category: 'ml' },
  { id: 'tesseract', name: 'tesseract', category: 'ml' },
];

export const categories = {
  core: { label: 'Core', color: 'from-purple-500 to-pink-500' },
  testing: { label: 'Testing', color: 'from-cyan-500 to-blue-500' },
  cloud: { label: 'Cloud', color: 'from-orange-500 to-red-500' },
  devops: { label: 'DevOps', color: 'from-green-500 to-emerald-500' },
  tools: { label: 'Tools', color: 'from-yellow-500 to-amber-500' },
  ml: { label: 'ML', color: 'from-indigo-500 to-purple-600' },
};
